import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  withStyles,
  Box,
  InputLabel,
  InputAdornment,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { history } from "../../../../../helpers/history";
import { routePaths } from "../../../../config/route-paths";
import { userService } from "../../../../../services/index";
import Alert from "@material-ui/lab/Alert";
import Countdown from "react-countdown-now";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import { MenuItem, Select } from "@material-ui/core";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import { useMediaQuery } from "react-responsive";
import FormControl from "@material-ui/core/FormControl";
import InputBase from '@material-ui/core/InputBase';
const useStyles = makeStyles((theme) => ({
  sendOTPTitle: {
    color: theme.palette.ePrimary.base,
    marginTop: "10%",
  },
  inpField: {
    width: "70%",
    marginTop: "10%",
  },
  mobileField: {
    //paddingLeft: "1rem",
  },
  alertMessage: {
    color: theme.palette.eDanger.dark,
    backgroundColor: theme.palette.eDanger.light,
    fontSize: "0.75rem",
  },
  buttonStyling: {
    width: "70%",
    background: theme.palette.ePrimary.base + " !important",
    color: theme?.palette?.eWhite?.base + " !important",
    borderRadius: "15px !important",
    marginTop: "10% !important",
    "&:hover": {
      background: theme.palette.ePrimary.hover + " !important",
    },
  },
  mobileNumberError: {
    fontSize: "0.75em",
    color: theme.palette.eDanger?.dark + "!important",
    textAlign: "left",
  },
  canceButton: {
    color: theme.palette.ePrimary.base + " !important",
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "none",
    },
    marginLeft: "0.5rem !important",
    textTransform: "none",
    marginTop: "5%",
  },
  errorSpace: {
    padding: "2%",
  },
  circularProgressColor: {
    color: theme?.palette?.eWhite?.base + " !important",
  },
  otpHintStyling: {
    padding: "1.5rem !important",
    justifyContent: "center",
  },
  mobileExt: {
    "& .MuiInputBase-input": {
      textAlign: "center",
    },
  },
  mainDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      height: "29rem",
    },
    [theme.breakpoints.up("md")]: {
      height: "24rem",
    },
  },
  margin: {
    marginTop: theme.spacing(0),
  },
}));
export const CssTextField = withStyles((theme) => ({
  root: {
    "& label": {
      width: "100%",
      textAlign: "center",
      transformOrigin: "center",
      fontSize: "1rem",
      color: theme.palette.eRich.base,
    },
    "& .MuiInputBase-input": {
      fontSize: "0.8em",
    },
    "& .MuiInputBase-input:focus": {
      fontSize: "1rem !important",
    },
    "& .MuiInput-formControl": {},
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark,
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiFormLabel-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.eDanger?.dark,
    },
  },
}))(TextField);
const inputStyle = { transitionDelay: "9999s" };

export const STYLED_SELECT = withStyles((theme) => ({
  root: {
    color: theme.palette.secondary.main + " !important",
    fontSize: "15px",
    border: "1px solid " + theme.palette.secondary.main + " !important",
    borderRadius: "4px",
    padding: "7px 10px",
    display:'flex'+" !important",
  },
  select: {
    "&:focus": {
      borderRadius: "4px",
    },
    whiteSpace: "nowrap",
  },
  icon: {
    color: theme.palette.secondary.main + " !important",
  },
}))(Select);
export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    justifyContent: "flex-start !important",
    color: theme.palette.secondary.main + " !important",
    fontSize: "15px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.primary.main,
      },
    },
    "&:focus": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.primary.main,
      },
    },
  },
}))(MenuItem);

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid grey',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 4,
      borderColor:'grey',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

export default function ESendOtp(props) {
  const classes = useStyles();
  const [propsInfo, setPropsInfo] = useState({
    userName: "",
    userRequire: false,
    userError: false,
    error: false,
    msg: null,
    isSignupLoading: false,
    errorCode: null,
    loginHelperText: "",
    emailError: "",
    blockUser: false,
    showDropdown:false,
    cNoArray:[],
    cNo:'',
    cNoError:false,
    cNoRequire:false,
  });
  const [mobErr, setmobErr] = useState(false)
  const [mobReq, setMobReq] = useState(false)
  const isTabletOrMobile = useMediaQuery({ maxWidth: 577 });
  const [timeCountdown, setTimeCountdown] = useState();
  const [countdownerror, setCountdownerror] = useState(false);
  const [content, setContent] = useState();
  const [enterOptText, setEnterOTPText] = useState();
  const [emailId, setEmailId] = useState("");
  const [cNo, setcNo] = useState();
  const [pickedAcno,setPickedCno]=useState()
  const EMAIL_REGEX = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.EMAIL_REGEX
  );

  const lockDurationDefault = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.LOCK_DURATION
  );
  const { t: loginLabels, ready: loginLabelReady } = useTranslation("label-E_AUTH_LOGIN");
  const { t: labels, ready: labelReady } = useTranslation("label-E_LOGIN_VIA_OTP");

  const { t: OTPLabels, ready: otpLabelReady } = useTranslation("label-E_VERIFY_SIGN_UP_OTP");
  const { t: forgotPwdLabels, ready: forgotPwdLabelReady } = useTranslation("label-E_AUTH_FORGOT_PASSWORD");
  const mobileLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_MOBILE_LENGTH);
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const country_Calling_Code = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_PHONE_NUMBER_EXTENSION
  );

  let country_Calling_Code_backend =
  useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_MOBILE_NUMBER_EXTENSION_BACKEND
  );

  const MOBILE_LENGTH = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_MOBILE_LENGTH
  );
  const mobileRegex = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_APPLICANT_MOBILE_REGEX
  );
  const digitsRegex = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_DIGITS_REGEX
  );
  const minLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_MIN_CN_LENGTH);
  const { t: otpContent, ready: contentReady } = useTranslation("content-E_LOGIN_VIA_OTP_CONTENT");
  const ddlMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    getContentAnchorEl: null,
  };
  const usernameBlur = () => {
    if (emailId) {
      setPropsInfo({
        ...propsInfo,
        userRequire: false,
        error: false,
        userError: false,
      });
      setmobErr(false)
      setMobReq(false)
      let emailRegEx = new RegExp(
        "^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$"
      );
      let test = emailRegEx.test(emailId);
      var mobileRegExp = new RegExp(mobileRegex);
      var mobileTest = mobileRegExp.test(emailId);

      if (mobileTest && emailId.length == MOBILE_LENGTH) {
        setPropsInfo({...propsInfo, userError: false });
        setmobErr(false)
      } else {
        setPropsInfo({...propsInfo, userError: true });
        setmobErr(true)
      }
    } else {
      setMobReq(true)
      setmobErr(false)
      setPropsInfo({
        ...propsInfo,
        userRequire: true,
        userError: false,
      });
    }
  };
  const keypress = (event) => {
    if (event.key === "Enter") {
      sendOTPHandeler(event);
    }
  };
  const backCall = () => {
    history.push(routePaths.LOGIN);
  };
  const sendOTPHandeler = () => {
    usernameBlur();
    cNoBlur();
    const userName = country_Calling_Code_backend+emailId;
    if (userName) {
      if (!mobErr && !mobReq && emailId!="" && propsInfo.cNo) {
        setPropsInfo({
          ...propsInfo,
          isSignupLoading: true,
        });
        localStorage.setItem("updating",propsInfo.cNo)
        if (props.path === routePaths.FORGOT_PASSWORD) {
          props
            .forgotPassword(emailId, "SEND_OTP","","",propsInfo.cNo)
            .then((response) => {
              localStorage.removeItem("flowType");
              localStorage.setItem("flowType", "FORGOT_PASSWORD");
              history.push({
                pathname: routePaths.LOGIN_VERIFY_OTP,
                state: {
                  path: routePaths.FORGOT_PASSWORD,
                  userName: userName,
                  mobile: "",
                },
              });
              setPropsInfo({
                ...propsInfo,
                isSignupLoading: false,
              });
            })
            .catch((error) => {
              if (
                error.response &&
                error.response.data.statusCode === 403 &&
                error.response.data.message
              ) {
                let errMessage, errMessageCode, terminationDate;
                errMessage = error.response.data.message;
                if (errMessage.indexOf("|") > 0) {
                  errMessageCode = errMessage.split("|")[0];
                  terminationDate = errMessage.split("|")[1];
                  if (errMessageCode === "ACCOUNT_TERMINATED_INVALID_SA") {
                    history.push(
                      routePaths.LOGIN +
                        "?flowCode=userAccountDeactivated&terminationDate=" +
                        terminationDate
                    );
                  } else {
                    history.push(
                      routePaths.LOGIN +
                        "?flowCode=userBlockedTemp&min=" +
                        error.response.data.message
                    );
                  }
                } else {
                  setPropsInfo({
                    ...propsInfo,
                    isSignupLoading: false,
                    blockUser: true,
                    msg: null,
                  });
                  if (error.response.data.message === "User Blocked") {
                    setTimeCountdown(Date.now() + 60000 * lockDurationDefault);
                  } else {
                    setTimeCountdown(
                      Date.now() + 60000 * error.response.data.message
                    );
                  }
                }
              } else if (
                error.response &&
                error.response.data.statusCode === 400 &&
                error.response.data.message &&
                error.response.data.message === "SIGN_UP_OTP_NOT_VERIFIED"
              ) {
                setPropsInfo({
                  ...propsInfo,
                  error: true,
                  msg: forgotPwdLabelReady ? forgotPwdLabels("E_FP_ACCOUNT_NOT_ACTIVATED") : '',
                  errorCode: error.response.data.statusCode,
                  isSignupLoading: false,
                });
              } else {
                setPropsInfo({
                  ...propsInfo,
                  error: true,
                  msg: error.response.data.message,
                  errorCode: error.response.data.statusCode,
                  isSignupLoading: false,
                });
              }
            });
        } else {
          userService
            .loginViaOTP(userName)
            .then((response) => {
              if(Array.isArray(response)){
                if(pickedAcno==undefined){
                  setPropsInfo({
                    ...propsInfo,
                    showDropdown:true,
                    isSignupLoading: false,
                    cNoArray:response,
                  });
                }
                if(pickedAcno!=undefined){
                  setPropsInfo({
                    ...propsInfo,
                    showDropdown:false,
                    isSignupLoading: true,
                  });
                  localStorage.removeItem("flowType");
                  localStorage.setItem("flowType", "OTP_LOGIN");
                  userService.loginViaOTP(userName,'Y',pickedAcno).then(resp=>{
                    if(resp?.isOk==true){
                     let pickedNumer= localStorage.getItem("pickedCno")
                     pickedNumer=JSON.parse(pickedAcno)
                      if(pickedNumer){
                        history.push({
                          pathname: routePaths.LOGIN_VERIFY_OTP,
                          state: {
                            path: routePaths.LOGIN_VIA_OTP,
                            userName: userName,
                            customerNumber:pickedAcno,
                            mobile: "",
                          },
                        });
                      }
                    }
                    setPropsInfo({
                      ...propsInfo,
                      showDropdown:false,
                      isSignupLoading: false
                    });
                  })
                  .catch(error=>{
                   if( error.response.data.statusCode == 404 ||
                    error.response.data.message=="ACCESS_REVOKED"){
                      setPropsInfo({
                        ...propsInfo,
                        showDropdown:false,
                        isSignupLoading: false,
                        msg:'You have no longer access to the  DPDC Impresa CX customer portal'
                      });
                    }
                    
                  })
                }
              }else{
                localStorage.removeItem("flowType");
                localStorage.setItem("flowType", "OTP_LOGIN");
                history.push({
                  pathname: routePaths.LOGIN_VERIFY_OTP,
                  state: {
                    path: routePaths.LOGIN_VIA_OTP,
                    userName: userName,
                    mobile: "",
                  },
                });
                setPropsInfo({
                  ...propsInfo,
                  isSignupLoading: false,
                });
              }
              
            })
            .catch((error) => {
              if (
                error.response &&
                error.response.data.statusCode === 403 &&
                error.response.data.message
              ) {
                let errMessage, errMessageCode, terminationDate;
                errMessage = error.response.data.message;
                if (errMessage.indexOf("|") > 0) {
                  errMessageCode = errMessage.split("|")[0];
                  terminationDate = errMessage.split("|")[1];
                  if (errMessageCode === "ACCOUNT_TERMINATED_INVALID_SA") {
                    history.push(
                      routePaths.LOGIN +
                        "?flowCode=userAccountDeactivated&terminationDate=" +
                        terminationDate
                    );
                  } else {
                    history.push(
                      routePaths.LOGIN +
                        "?flowCode=userBlockedTemp&min=" +
                        error.response.data.message
                    );
                  }
                } else {
                  setPropsInfo({
                    ...propsInfo,
                    isSignupLoading: false,
                    blockUser: true,
                    msg: null,
                  });
                  if (error.response.data.message === "User Blocked") {
                    setTimeCountdown(Date.now() + 60000 * lockDurationDefault);
                  } else {
                    setTimeCountdown(
                      Date.now() + 60000 * error.response.data.message
                    );
                  }
                }
              } else {
                setPropsInfo({
                  ...propsInfo,
                  error: true,
                  msg:  error.response.data.statusCode==404 && error.response.data.message=="ACCESS_REVOKED" ? "You have no longer access to the  DPDC Impresa CX customer portal":error.response.data.message,
                  errorCode: error.response.data.statusCode,
                  isSignupLoading: false,
                });
              }
            });
        }
      }
    }
  };

  let cNoBlur = () => {

    if (propsInfo.cNo) {
       setPropsInfo({
        ...propsInfo,
        cNoError:false,
        cNoRequire:false
      });
      if (propsInfo.cNo?.length <= mobileLength && propsInfo.cNo?.length >=minLength ) {
        setPropsInfo({
          ...propsInfo,
          cNoError:false,
        });
      } else {
        setPropsInfo({
          ...propsInfo,
          cNoError:true,
        });
      }
    } else {
      setPropsInfo({
        ...propsInfo,
        cNoRequire:true,
      });
    }
  }

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    if(name=='username'){
      var digitsRegexS = new RegExp(digitsRegex);
      if (event.target.value === "" || digitsRegexS.test(event.target.value)) {
        setPropsInfo({
          ...propsInfo,
          userName: event.target.value,
          error: false,
        });
        setEmailId(event.target.value);
        props.setcustNo(event.target.value)
      }
    }
    else if(name=="customerNumber"){
      if(event.target.value != "" && value.length<=mobileLength){
        setPropsInfo({
          ...propsInfo,
          cNo:Math.max(0, parseInt(value) ).toString().slice(0,parseInt(mobileLength)),
          cNoError:true,
          cNoRequire:false
        });
        props.setcustNo(Math.max(0, parseInt(value) ).toString().slice(0,parseInt(mobileLength)))
      }
      if(event.target.value === ""&& value.length<=mobileLength){
        setPropsInfo({
          ...propsInfo,
          cNo: event.target.value,
          cNoError:false,
          cNoRequire:false
        });
        props.setcustNo(event.target.value)
      } 
      if(event.target.value != "" && value.length>mobileLength){
        setPropsInfo({
          ...propsInfo,
          cNo:Math.max(0, parseInt(value) ).toString().slice(0,parseInt(mobileLength)),
        });
        props.setcustNo(Math.max(0, parseInt(value) ).toString().slice(0,parseInt(mobileLength)))
      }



      // if (event.target.value === "" || digitsRegexS.test(event.target.value)) {
      //   setPropsInfo({
      //     ...propsInfo,
      //     cNo: event.target.value,
      //   });
      //   setEmailId(event.target.value);
      // }
    }
  };

  function countDowninMinutes({ minutes, completed }) {
    let newAfter = loginLabelReady ? loginLabels("E_USER_BLOCKED")?.replace("***", minutes + 1) : '';
    if (completed) {
      setCountdownerror(false);
      return (
        <div>
          <span></span>
        </div>
      );
    } else {
      return (
        <div>
          <React.Fragment>
            <Alert className={classes.alertMessage} severity="error">
              <Typography
                className={classes.whiteColor}
                variant="caption"
                align="center"
                dangerouslySetInnerHTML={{
                  __html: newAfter,
                }}
              />
            </Alert>
          </React.Fragment>
        </div>
      );
    }
  }

  const displayDropdownChange=(e)=>{
    if(!isNaN(e.target.value)){
      localStorage.setItem("pickedCno",e.target.value)
      setPickedCno(e.target.value)
    }
    
  }

  // useEffect(()=>{
  //   if(propsInfo?.cNoArray && pickedAcno==null){
  //     setPickedCno(propsInfo?.cNoArray[0])
  //   }
  // },[propsInfo?.cNoArray,pickedAcno])
  return (
    <div className={classes.mainDiv}>
      <Grid container justify="space-around">
        <Grid item xs={12} sm={12} md={12} lg={12}>
        {
          labelReady?
          <Typography variant="h5" className={classes?.sendOTPTitle}>
            {labels("E_SEND_OTP_TITLE")}
          </Typography>
          : <Skeleton />
        }
        </Grid>
      </Grid>
      <Grid container justify="center">
        <Grid item className={classes.inpField}>
          <Grid container spacing={1}>
            {/* <Grid item xs={2}>
              <CssTextField
                value={country_Calling_Code}
                variant="standard"
                autoComplete="off"
                className={classes.mobileExt}
                error={propsInfo?.userRequire || propsInfo?.userError}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid> */}
            <Grid item xs={12}>
              <CssTextField
                placeholder={loginLabelReady ? loginLabels("E_CN_TEXT") : ''}
                fullWidth
                type="number"
                autoComplete="off"
                variant="standard"
                id="Email_Id"
                name="customerNumber"
                value={propsInfo.cNo}
                onChange={handleChangeInput}
                onBlur={cNoBlur}
                className={classes.mobileField}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  maxLength: mobileLength,
                }}
                onKeyPress={keypress}
                label={labelReady ? labels?.E_LOGIN_VIA_OTP_MOBILE_TITLE : ''}
                error={propsInfo?.cNoError || propsInfo?.cNoRequire}
              />
              <Typography className={classes.mobileNumberError}>
              {propsInfo?.cNoError === true ? (
                loginLabelReady ? loginLabels("E_AUTH_LOGIN_MOBILE_ERROR") : ''
              ) : propsInfo?.cNoRequire === true ? (
                loginLabelReady ? loginLabels("E_AUTH_LOGIN_EMAIL_REQUIRE") : ''
              ) : (
                <span className={classes.errorSpace}>&nbsp;</span>
              )}
              {propsInfo.cNoError}
            </Typography>
            </Grid>
            <Grid item xs={12}>
              <CssTextField
                placeholder={labelReady ? labels("NESCO_MOBILE_NUMBER_PLACEHOLDER") : ''}
                fullWidth
                autoComplete="off"
                variant="standard"
                id="Email_Id"
                name="username"
                value={emailId}
                onChange={handleChangeInput}
                onBlur={usernameBlur}
                className={classes.mobileField}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  maxLength: MOBILE_LENGTH,
                  style: inputStyle,
                }}
                onKeyPress={keypress}
                label={labelReady ? labels?.E_LOGIN_VIA_OTP_MOBILE_TITLE : ''}
                error={mobReq || propsInfo?.userRequire || propsInfo?.userError || mobErr}
                InputProps={{
                  startAdornment: <InputAdornment position="start">{country_Calling_Code_backend}</InputAdornment>,
                }}
              />
            </Grid>
            <Typography className={classes.mobileNumberError}>
              {mobErr === true ? (
                labelReady ? labels("E_LOGIN_VIA_OTP_INVALID_MOBILE_TITLE") : ''
              ) : mobReq==true ? (
                labelReady ? labels("E_LOGIN_VIA_OTP_MOBILE_REQUIRED_TITLE") : ''
              ) : (
                <span className={classes.errorSpace}>&nbsp;</span>
              )}
            </Typography>
          </Grid>
          <Grid container spacing={1}>
          <div >
                {propsInfo?.showDropdown &&
                  <FormControl style={{width: '-webkit-fill-available',
                  display: 'block'}} className={classes.margin}>
                      <Select
                        id="demo-simple-select"
                        labelId="demo-simple-select-label"
                        value={pickedAcno?pickedAcno:"Select Customer Number"}
                        onChange={displayDropdownChange}
                        defaultValue={pickedAcno?pickedAcno:"Select Customer Number"}
                        input={<BootstrapInput />}
                        style={{width:'15rem'}}
                        className={classes.mobileField}
                        label={"Select Customer Number"}
                      >
                        <MenuItem  selected value="Select Customer Number">
                         <Typography variant="body2"> Select Customer Number</Typography>
                        </MenuItem>
                        {propsInfo?.cNoArray.map((e)=>(
                          <MenuItem value={e}> <Typography variant="body2">{e}</Typography></MenuItem>
                        ))}
                      </Select>
                      </FormControl>
                  }
        </div>
          </Grid>
        </Grid>
      </Grid>
      <Grid container justify="space-around">
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Button
            variant="contained"
            className={classes.buttonStyling}
            onClick={sendOTPHandeler}
          >
            {labelReady ? labels("E_LOGIN_VIA_OTP_BUTTON_TITLE") : <Skeleton />}
            {propsInfo?.isSignupLoading && (
              <CircularProgress
                size={18}
                className={classes.circularProgressColor}
              />
            )}
          </Button>
        </Grid>
      </Grid>
      <Grid container justify="space-around">
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Button className={classes.canceButton} onClick={backCall}>
          {
            otpLabelReady?
            <Typography variant="caption">
              {OTPLabels("E_CANCEL_BUTTON_TITLE")}
            </Typography>
            : <Skeleton />
          }
          </Button>
        </Grid>
      </Grid>
      <Grid contiainer justify="space-around">
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.pd5}>
          {propsInfo?.msg && (
            <Alert severity="error" className={classes.alertMessage}>
              {propsInfo?.msg}
            </Alert>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {propsInfo?.blockUser ? (
            <React.Fragment>
              <Countdown date={timeCountdown} renderer={countDowninMinutes} />
            </React.Fragment>
          ) : null}
        </Grid>
      </Grid>
      <Grid container className={classes?.otpHintStyling}>
        <Grid item>
        {
          contentReady ?
          <Typography variant="caption">
            {propsInfo?.showDropdown?"The entered mobile number is linked with more than one customer number. Please select one customer number and click on Send OTP": otpContent("E_LOGIN_VIA_OTP_DESCRIPTION").answer}
          </Typography>
          : <Skeleton />
        }
        </Grid>
      </Grid>
    </div>
  );
}
